import api from 'api'
import {
  CACHE_TAG_INVOICE_VERSION_LIST,
  CACHE_TAG_ACCOUNT_EMAIL_EVENT_LIST,
  CACHE_TAG_ACCOUNT_INVOICE_LIST,
  CACHE_TAG_INVOICE_LIST,
} from 'api/cacheTagTypes'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'
import { withIdTag } from 'utils/cache'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    postAndSendInvoiceList: build.mutation({
      query: body => ({ url: '/api/v1/billing/invoice/post-and-send', method: 'POST', body }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_INVOICE_VERSION_LIST,
        ...withIdTag(CACHE_TAG_ACCOUNT_EMAIL_EVENT_LIST, arg?.accountId),
        CACHE_TAG_ACCOUNT_INVOICE_LIST,
        CACHE_TAG_INVOICE_LIST,
        ...WORK_ORDER_CACHE_INVALIDATION_TAGS,
      ],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { usePostAndSendInvoiceListMutation } = extendedApi
